import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import { useTranslate } from "ra-core";
import { useCreateDirectoryDialog } from "../dialogs/create-directory-dialog/CreateDirectoryDialogProvider";

const DirectoryUploadButton = (props) => {
    const { onClick, fileSystemNodePath } = props;
    const translate = useTranslate();
    const dialog = useCreateDirectoryDialog();
    const handleOnClick = () => {
        dialog.open(fileSystemNodePath);
        onClick();
    }
    return (
        <ListItem button onClick={handleOnClick}>
            <ListItemIcon>
                <CreateNewFolderIcon/>
            </ListItemIcon>
            <ListItemText primary={translate(`cmss.resources.file-explorer.directory-actions-menu.buttons.create-directory`)} />
        </ListItem>
    ) 
};
export default DirectoryUploadButton;
